module.exports = __webpack_public_path__ + "HazeSmokeNightV2_106.svg";